import React from 'react';

const MobileStickyBar = () => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white shadow-2xl border-t-2 border-[#5c0701] z-40">
      <div className="flex items-center justify-between px-4 py-3">
        <a
          href="tel:2036043202"
          className="flex-1 bg-[#3a87fe] text-white py-3 rounded-lg font-semibold text-center mr-2 hover:bg-[#2968d9] transition flex items-center justify-center gap-2"
          data-testid="mobile-sticky-call"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
          Call Now
        </a>
        <a
          href="mailto:codyvisser5@gmail.com"
          className="flex-1 bg-[#5c0701] text-white py-3 rounded-lg font-semibold text-center hover:bg-[#7a0901] transition flex items-center justify-center gap-2"
          data-testid="mobile-sticky-email"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
          Email
        </a>
      </div>
    </div>
  );
};

export default MobileStickyBar;